//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    styleData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      shortView: true
    }
  },
  computed: {
    getGenres() {
      const genres = [...this.styleData]
      let sortedGenres = [...genres]
      if (this.$route.query.hasOwnProperty('style')) {
        sortedGenres = genres.sort((a, b) => {
          const aSelected = this.$route.query.style.indexOf(a.id.toString()) > -1
          const bSelected = this.$route.query.style.indexOf(b.id.toString()) > -1
          return (aSelected && bSelected) || (!aSelected && !bSelected) ? 0 : aSelected ? -1 : 1
        })
      }
      return this.shortView ? this.shortgenres(sortedGenres) : sortedGenres
    }
  },
  methods: {
    chooseGenres (genre) {
      if (genre === '...') {
        this.shortView = false
        return
      }
      if (typeof this.$route.query.style === 'string') {
        this.$route.query.style = [this.$route.query.style]
      }
      const queryGenres = this.$route.query.style ? [...this.$route.query.style] : []
      const index = queryGenres.indexOf(genre.toString())
      if (index > -1) {
        queryGenres.splice(index, 1)
      } else {
        queryGenres.push(genre)
      }
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          style: queryGenres
        }
      })
    },
    shortgenres(sortedGenres) {
      let selected = []
      if (this.$route.query.hasOwnProperty('style')) {
        console.log(this.$route.query.style)
        selected = sortedGenres.filter(elem => this.$route.query.style.indexOf(elem.id.toString()) > -1)
        this.$route.query.style
      }
      const visibleGenres = selected.length > 5 ? selected.length : 5
      const result = [...sortedGenres.slice(0, visibleGenres)]
      if (sortedGenres.length > 5) {
        result.push({name: "...", id: '...'})
      }
      return result
    },
  },
  // chimera: {
  //   genres () {
  //     return {
  //       // в nuxt.config.js комент по поводу url
  //       // url: '/gallery/getItemCategories/',
  //       url: '/api/v1/gallery/getItemCategories/',
  //       key: '/gallery/getItemCategories/',
  //       auto: true,
  //       params: {
  //         lang: this.$i18n.locale || 'ru'
  //       }
  //     }
  //   }
  // },
}
